import { useEffect } from 'react'
import { useAtomValue, useSetAtom } from 'jotai'
import { accountCapabilitiesAtom } from 'hooks/capabilities/atoms/capabilitiesAtoms'
import { useBvnkNetworkConnectionsQuery } from 'hooks/queries/BvnkNetwork/useBvnkNetworkConnectionsQuery'
import {
  bvnkNetworkConnectionsAtom,
  isFetchingConnectionsAtom,
  isFetchingConnectionsErrorAtom,
} from 'pages/BvnkNetwork/atoms/bvnkNetworkAtoms'

export const useSetBvnkNetworkConnections = (accountReference: string) => {
  const accountCapabilities = useAtomValue(accountCapabilitiesAtom)
  const setBvnkNetworkConnections = useSetAtom(bvnkNetworkConnectionsAtom)
  const setIsFetchingBvnkNetwork = useSetAtom(isFetchingConnectionsAtom)
  const setIsFetchingConnectionsError = useSetAtom(isFetchingConnectionsErrorAtom)

  const {
    data: bvnkNetworkConnections,
    isFetching: isFetchingConnections,
    isError: isFetchingConnectionsError,
  } = useBvnkNetworkConnectionsQuery(
    {
      accountReference,
    },
    !!accountReference && accountCapabilities?.isBvnkNetworkCapabilityEnabled
  )

  useEffect(() => {
    setBvnkNetworkConnections(bvnkNetworkConnections)
    setIsFetchingBvnkNetwork(isFetchingConnections)
    setIsFetchingConnectionsError(isFetchingConnectionsError)
  }, [bvnkNetworkConnections, isFetchingConnections, isFetchingConnectionsError])
}
